// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2tBla","box":"WorkspacesBox_box__Xf6lz","node":"WorkspacesBox_node__39Ri2"};